import { useState } from "react";
import { Text } from "@rshbintech.dboul/core-ui";
import { Notification } from "../types";
import { useAppTranslation } from "../../../../hooks";
import { NotificationItem } from "./notification-item";
import { NotificationDetails } from "./notification-details";
import { getDateFromISO } from "./utils";
import { NotificationsContentProps } from "./types";
import styles from "./styles.scss";

export const NotificationsContent = ({
  notificationsList,
  onScroll,
  containerRef,
}: NotificationsContentProps) => {
  const [isNotificationDetailsOpened, setNotificationDetailsOpened] =
    useState<boolean>(false);

  const { translate } = useAppTranslation("NOTIFICATION");

  const [notificationData, setNotificationData] = useState<Notification | null>(
    null
  );

  const handleOpenNotificationDetails = (notification: Notification) => {
    setNotificationData(notification);
    setNotificationDetailsOpened(true);
  };

  const handleCloseNotificationDetails = () => {
    setNotificationDetailsOpened(false);
  };

  const months = translate("UTILS.MONTHS", { returnObjects: true });

  const formattedNotificationList = notificationsList.map((notification) => ({
    ...notification,
    date: getDateFromISO(
      notification.date,
      months as string[],
      translate("UTILS.TODAY_TITLE")
    ),
  }));

  return (
    <>
      <div ref={containerRef} onScroll={onScroll} className={styles.content}>
        {notificationsList.length ? (
          formattedNotificationList.map((notification) => (
            <NotificationItem
              key={notification.id}
              notificationData={notification}
              onClick={() => handleOpenNotificationDetails(notification)}
            />
          ))
        ) : (
          <Text className={styles["empty-list-content"]}>
            {translate("EMPTY_LIST_CONTENT")}
          </Text>
        )}
      </div>
      <NotificationDetails
        isOpened={isNotificationDetailsOpened}
        onClose={handleCloseNotificationDetails}
        notificationData={notificationData}
      />
    </>
  );
};
